<template>
<el-container>
 <el-main> 
    <el-form :inline="true" :model="formRecord" class="demo-form-inline">
        <el-form-item :label="$t('systemRecord.beginTime')">
          <el-date-picker v-model="formRecord.beginTime" type="datetime" :placeholder="$t('systemRecord.chooseDate')">
         </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('systemRecord.endTime')">
          <el-date-picker v-model="formRecord.endTime" type="datetime" :placeholder="$t('systemRecord.chooseDate')">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSelect">{{$t('systemRecord.qurey')}}</el-button>
          <!-- <el-button type="primary" @click="onCreate">增加网关</el-button> -->
        </el-form-item>
    </el-form>
      <el-table :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#606266'}" style="margin-top:5px" empty-text="No Data" border>
        <el-table-column type="index" :label="$t('systemRecord.number')" width="100" align="center"></el-table-column>
        <el-table-column prop="operation" :label="$t('systemRecord.operate')" align="center" width="160"></el-table-column>
        <el-table-column prop="message" :label="$t('systemRecord.operateResult')" align="center"></el-table-column>
        <el-table-column prop="userName" :label="$t('systemRecord.operater')" align="center"></el-table-column>
        <el-table-column prop="createTime" :formatter="this.$util.datetimeFormat" :label="$t('systemRecord.operateTime')" align="center"></el-table-column>
      </el-table>
  </el-main>
  <el-footer>
    <div>
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChange"
          @handleCurrentChangeSub="handleCurrentChange"
        ></Pagings>
    </div>
  </el-footer>    
</el-container>  
</template>
<script>
import Pagings from "./common/Pagings.vue";
export default {
  name: "systemRecord", //这个LoginName最好和引入的vue的LoginName相同
   data() {
    return {
      pageData: {
        offset: 1,
        pageNumber: 10
      },
      total: 1, //总条数
      tableData: [],
      formRecord: {
        roleName: "",
        beginTime:new Date().setMonth(new Date().getMonth()-1),//当前时间后退一个月
        endTime:new Date()
      }
    };
  },
  components: {
    Pagings
  },
   created() {
    this.power();
  },
  methods: {
    onSelect(){
      this.pageData.offset=1;
      this.power();
    },
    power() {
      if(this.$util.formartDateTime(this.formRecord.beginTime)>this.$util.formartDateTime(this.formRecord.endTime)){
          this.$message({
              message:  this.$t("systemRecord.benginEndThanTime"),
              type: "warning"
          });
          return false;
      }
      var formData = new FormData();
      if(this.formRecord.beginTime!=null && this.formRecord.beginTime!=""){
         formData.append("beginTime",this.$util.formartDateTime(this.formRecord.beginTime));
      }
      if(this.formRecord.endTime!=null && this.formRecord.endTime!=""){
         formData.append("endTime", this.$util.formartDateTime(this.formRecord.endTime));
      }
    
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      this.$server
        .exam("/customer/operation/listOperation", formData)
        .then(data => {
          if (data.code == 200) {
            this.tableData = data.data.records;
            this.total = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

    handleSizeChange(val) {
      this.pageData.pageNumber = val;
      this.power();
    },
    handleCurrentChange(val) {
      this.pageData.offset = val;
      this.power();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/systemRecord.vue